<div class="library-upload-view">
  <div class="flex-container">
    <div class="flex-item">
      <div
        class="card"
        appInfiniteScroll
        infinite-scroll
        [scrollWindow]="true"
        [infiniteScrollDistance]="modalScrollDistance"
        [infiniteScrollThrottle]="modalScrollThrottle"
      >
        <!-- <div class="card-header">
        <p class="card-header-title">Create new lesson</p>
      </div> -->
        <div class="card-content pos-relative" style="display: none">
          <div class="dropdown is-hoverable">
            <div
              class="dropdown-trigger"
              (click)="llmFileInput.click()"
              data-tooltip="Upload File..."
            ></div>
            <div class="file">
              <label class="file-label">
                <input
                  type="file"
                  name="msg-file"
                  id="uploadfile"
                  style="display: none"
                  (change)="chooseUploadFilellm($event)"
                  #llmFileInput
                  accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label"> Upload a file… </span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div
          class="tabs is-info is-outlined is-fullwidth is-small questionariesTab"
        >
          <ul>
            <!-- <li class="is-active"><a>Interactive video</a></li> -->
            <!-- <li
            class="tab "
            (click)="openTab($event, 'trainllm')"
            >
            <a>Train Model</a>
          </li> -->
            <li class="tab is-active" (click)="openTab($event, 'lesson')">
              <a>New Policy</a>
            </li>
            <!-- <li
          class="tab"
          (click)="openTab($event, 'assessment')"
          >
          <a>Assessment</a>
        </li>
        <li class="tab" (click)="openTab($event, 'survey')">
          <a>Survey</a>
        </li>
        <li class="tab" (click)="openTab($event, 'poll')">
          <a>Poll</a>
        </li>
        <li class="tab" (click)="openTab($event, 'notes')">
          <a>Notes</a>
        </li> -->
          </ul>
        </div>
        <div class="card-body py-0">
          <form [formGroup]="uploadFileForm" novalidate>
            <div class="pos-relative" infinite-scroll>
              <div class="row is-clearfix">
                <div
                  class="column upload-file-form is-5 scroll-bar"
                  style="display: none"
                >
                  <div class="field post-attach-file">
                    <label
                      for=""
                      class="label has-tooltip-bottom"
                      data-tooltip="Attach only PNG, JPEG, JPG, MP3, MP4, WAV, PDF, PPT, PPTX, XML, XLS, XLSX, DOC, DOCX, TXT file"
                      >Upload File
                      <i
                        class="fa fa-info-circle mar-5-0"
                        aria-hidden="true"
                      ></i>
                      <span class="required">*</span>
                    </label>
                    <div
                      class="control profile-img"
                      [ngClass]="{ 'small-img': upLoadedFileList.length !== 0 }"
                    >
                      @if (upLoadedFileList.length === 0) {
                      <div>
                        <!-- <img
                      [src]="'../../../assets/images/empty-state-attach.png'"
                      /> -->
                      </div>
                      } @if (upLoadedFileList.length !== 0) {
                      <div class="is-small">
                        @for (f of uploadFileIcons; track f) {
                        <div>
                          @if (f.name === upLoadedFileList[0].mimeType) {
                          <span>
                            <img
                              [src]="f.icons"
                              alt=""
                              width="35px"
                              height="35px"
                            />
                            {{ upLoadedFileList[0].name }}
                            <button
                              class="delete"
                              aria-label="Delete"
                              (click)="removeUploadFile(upLoadedFileList)"
                            ></button>
                          </span>
                          }
                        </div>
                        }
                      </div>
                      } @if (upLoadedFileList.length === 0) {
                      <span class="img-options">
                        <div class="dropdown is-hoverable">
                          <div
                            class="dropdown-trigger"
                            (click)="elibraryFileInput.click()"
                            data-tooltip="Upload File..."
                          ></div>
                          <div class="file">
                            <label class="file-label">
                              <input
                                type="file"
                                name="msg-file"
                                id="uploadfile"
                                style="display: none"
                                (change)="chooseUploadFile($event)"
                                #elibraryFileInput
                                accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt"
                              />
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label"> Upload a file… </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </span>
                      }
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Duration</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        name="duration"
                        placeholder="Video/Audio File Duration"
                        formControlName="duration"
                        #durationInput
                        aria-disabled="true"
                        [readonly]="true"
                      />
                    </div>
                  </div>

                  <div class="field">
                    <label class="label"
                      >Title
                      <span class="required">*</span>
                    </label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        name="title"
                        placeholder="Title"
                        formControlName="title"
                      />
                      <form-validation
                        [control]="uploadFileForm.controls.title"
                      ></form-validation>
                    </div>
                  </div>
                  <div class="field responsiveRadioBtn">
                    <input
                      id="switchDownload"
                      type="checkbox"
                      name="download_link"
                      class="switch is-small is-success"
                      formControlName="download_link"
                      [(ngModel)]="isDownload"
                    />
                    <label for="switchDownload">Allow download?</label>
                  </div>
                  <div class="field responsiveRadioBtn">
                    <input
                      id="switchDownload"
                      type="checkbox"
                      name="download_link"
                      class="switch is-small is-success"
                      formControlName="download_link"
                      [(ngModel)]="isDownload"
                    />
                    <label for="switchDownload">Allow LLM?</label>
                  </div>
                  <!-- <div class="field responsiveRadioBtn">
                          <input
                            id="switchPublish"
                            type="checkbox"
                            name="publish"
                            class="switch is-small is-success"
                            formControlName="publish"
                            [(ngModel)]="isPublish"
                            />
                            <label for="switchPublish">Publish this lesson?</label>
                          </div> -->

                  <div class="field">
                    <label class="label">Description</label>
                    <div class="control">
                      <angular-editor
                        class="scroll-bar"
                        formControlName="description"
                        [config]="editorConfig"
                        cols="10"
                        rows="2"
                      ></angular-editor>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <div class="field">
                        <label class="label">Price $</label>
                        <div class="control">
                          <input
                            type="text"
                            class="input"
                            name="price"
                            placeholder="Price $"
                            formControlName="price"
                            (keypress)="numberOnlyValidator($event)"
                            (keydown)="IsDecimalValue($event)"
                          />
                          @if (priceValidate) {
                          <p class="is-small has-text-danger">
                            {{ priceErrMsg }}
                          </p>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <div class="field">
                        <label class="label">Discount %</label>
                        <div class="control">
                          <input
                            type="text"
                            class="input"
                            name="discount"
                            placeholder="Discount"
                            formControlName="discount"
                            (keypress)="isNumberKey($event)"
                            maxlength="3"
                            (keyup)="discountPercentage($event)"
                          />
                          @if (discountValidate) {
                          <p class="is-small has-text-danger">
                            {{ priceErrMsg }}
                          </p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">Watermark Title</label>
                    <div class="control">
                      <input
                        type="text"
                        class="input"
                        name="watermark_title"
                        placeholder="Watermark Title"
                        formControlName="watermark_title"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-6"> -->
                <!-- <div class="field"> -->

                <!-- <div class="container container-file scroll-bar"> -->
                <!-- <div id="trainllm" class="content-tab row">
                              <div class="card-content  pos-relative"  >
                                <div class="dropdown is-hoverable">
                                  <div
                                    class="dropdown-trigger"
                                    (click)="llmFileInput.click()"
                                    data-tooltip="Upload File..."
                                  ></div>
                                  <div class="file">
                                    <label class="file-label">
                                      <input
                                        type="file"
                                        name="msg-file"
                                        id="uploadfile"
                                        style="display: none"
                                        (change)="chooseUploadFilellm($event)"
                                        #llmFileInput
                                        accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt"
                                        />
                                        <span class="file-cta">
                                          <span class="file-icon">
                                            <i class="fa fa-upload"></i>
                                          </span>
                                          <span class="file-label"> Upload a file… </span>
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div> -->
                <div id="lesson" class="content-tab row">
                  <!-- <div class="scroll-bar"> -->
                  <div class="col-md-6">
                    <div class="field post-attach-file">
                      <label
                        for=""
                        class="label has-tooltip-bottom"
                        data-tooltip="Attach only PNG, JPEG, JPG, MP3, MP4, WAV, PDF, PPT, PPTX, XML, XLS, XLSX, DOC, DOCX, TXT file"
                        >Upload File
                        <i
                          class="fa fa-info-circle mar-5-0"
                          aria-hidden="true"
                        ></i>
                        <span class="required">*</span>
                      </label>
                      <div
                        class="control profile-img"
                        [ngClass]="{
                          'small-img': upLoadedFileList.length !== 0
                        }"
                      >
                        @if (upLoadedFileList.length === 0) {
                        <div>
                          <!-- <img
                                          [src]="'../../../assets/images/empty-state-attach.png'"
                                          /> -->
                        </div>
                        } @if (upLoadedFileList.length !== 0) {
                        <div class="is-small">
                          @for (f of uploadFileIcons; track f) {
                          <div>
                            @if (f.name === upLoadedFileList[0].mimeType) {
                            <span>
                              <img
                                [src]="f.icons"
                                alt=""
                                width="35px"
                                height="35px"
                              />
                              {{ upLoadedFileList[0].name }}
                              <button
                                class="delete"
                                aria-label="Delete"
                                (click)="removeUploadFile(upLoadedFileList)"
                              ></button>
                            </span>
                            }
                          </div>
                          }
                        </div>
                        } @if (upLoadedFileList.length === 0) {
                        <span class="img-options">
                          <div class="dropdown is-hoverable">
                            <div
                              class="dropdown-trigger"
                              (click)="elibraryFileInput.click()"
                              data-tooltip="Upload File..."
                            ></div>
                            <div class="file">
                              <label class="file-label">
                                <input
                                  type="file"
                                  name="msg-file"
                                  id="uploadfile"
                                  style="display: none"
                                  (change)="chooseUploadFile($event)"
                                  #elibraryFileInput
                                  accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .xml, .xls, .xlsx, .doc, .docx, .txt"
                                />
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fa fa-upload"></i>
                                  </span>
                                  <span class="file-label">
                                    Upload a file…
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </span>
                        }
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Duration</label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          name="duration"
                          placeholder="Video/Audio File Duration"
                          formControlName="duration"
                          #durationInput
                          aria-disabled="true"
                          [readonly]="true"
                        />
                      </div>
                    </div>

                    <div class="field">
                      <label class="label"
                        >Title
                        <span class="required">*</span>
                      </label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          name="title"
                          placeholder="Title"
                          formControlName="title"
                        />
                        <form-validation
                          [control]="uploadFileForm.controls.title"
                        ></form-validation>
                      </div>
                    </div>
                    <div class="field responsiveRadioBtn">
                      <input
                        id="switchDownload"
                        type="checkbox"
                        name="download_link"
                        class="switch is-small is-success"
                        formControlName="download_link"
                        [(ngModel)]="isDownload"
                      />
                      <label for="switchDownload">Allow download?</label>
                    </div>
                    <!-- <div class="field responsiveRadioBtn">
                                            <input
                                              id="switchDownload"
                                              type="checkbox"
                                              name="download_link"
                                              class="switch is-small is-success"
                                              formControlName="download_link"
                                              [(ngModel)]="isDownload"
                                              />
                                              <label for="switchDownload">Allow LLM?</label>
                                            </div> -->
                    <div class="field" style="display: none">
                      <label class="label">Watermark Title</label>
                      <div class="control">
                        <input
                          type="text"
                          class="input"
                          name="watermark_title"
                          placeholder="Watermark Title"
                          formControlName="watermark_title"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- <div class="field responsiveRadioBtn">
                                              <input
                                                id="switchPublish"
                                                type="checkbox"
                                                name="publish"
                                                class="switch is-small is-success"
                                                formControlName="publish"
                                                [(ngModel)]="isPublish"
                                                />
                                                <label for="switchPublish">Publish this lesson?</label>
                                              </div> -->

                    <div class="field">
                      <label class="label">Description</label>
                      <div class="control">
                        <angular-editor
                          class="scroll-bar"
                          formControlName="description"
                          [config]="editorConfig"
                          cols="10"
                          rows="2"
                        ></angular-editor>
                      </div>
                    </div>
                    <div class="field" style="display: none">
                      <label class="label">Price $</label>
                      <div class="control">
                        <input
                          type="text"
                          class="input"
                          name="price"
                          placeholder="Price $"
                          formControlName="price"
                          (keypress)="numberOnlyValidator($event)"
                          (keydown)="IsDecimalValue($event)"
                        />
                        @if (priceValidate) {
                        <p class="is-small has-text-danger">
                          {{ priceErrMsg }}
                        </p>
                        }
                      </div>
                    </div>

                    <div class="field" style="display: none">
                      <label class="label">Discount %</label>
                      <div class="control">
                        <input
                          type="text"
                          class="input"
                          name="discount"
                          placeholder="Discount"
                          formControlName="discount"
                          (keypress)="isNumberKey($event)"
                          maxlength="3"
                          (keyup)="discountPercentage($event)"
                        />
                        @if (discountValidate) {
                        <p class="is-small has-text-danger">
                          {{ priceErrMsg }}
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- </div>   -->
                </div>
                <div
                  id="assessment"
                  class="content-tab row"
                  style="display: none"
                >
                  <div class="col">
                    <div class="row">
                      <div class="col-12">
                        <div class="row pull-right">
                          <div class="col">
                            <div class="field">
                              <label class="label">Minimum % required</label>
                              <div class="control">
                                <input
                                  type="text"
                                  class="input"
                                  name="min_percentage"
                                  placeholder="%"
                                  formControlName="min_percentage"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <label class="label has-text-weight-bold"
                              >Allow to Re-Test?</label
                            >
                            <div class="field responsiveRadioBtn">
                              <input
                                id="switchReTest"
                                type="checkbox"
                                name="is_allow_retest"
                                class="switch is-small is-success"
                                formControlName="is_allow_retest"
                                [(ngModel)]="isAllowRetest"
                              />
                              <label for="switchReTest"></label>
                            </div>
                          </div>
                          <div class="col-auto">
                            <div class="field">
                              <label class="label"
                                >No.of Random Question
                                <span class="required">*</span></label
                              >
                              <div class="control">
                                <input
                                  type="text"
                                  class="input"
                                  name="random_question"
                                  placeholder=""
                                  formControlName="random_question"
                                  (keydown)="keyDownHandler($event)"
                                  (keypress)="numericOnlyHandler($event)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3">
                        @if (assQuestion().controls.length==0) {
                        <a
                          class="button is-link is-small has-tooltip-top mar-0-5"
                          data-tooltip="Add your first question"
                          (click)="onCreateAssQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add your assessment question
                        </a>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <ng-container formArrayName="assessment">
                        @for ( assessmentCtrl of assQuestion().controls; track
                        assessmentCtrl; let questIndex = $index) {
                        <div class="questionnarie row">
                          <div [formGroupName]="questIndex">
                            <div class="col">
                              <div class="row">
                                <div class="question-choice col-md-3">
                                  <div class="field">
                                    <div class="label">
                                      <label class="label"
                                        >Question Type
                                        <span class="required"> *</span>
                                      </label>
                                      <span class="control">
                                        @for ( item of questions; track item;
                                        let i = $index) {
                                        <div class="radio">
                                          <input
                                            [value]="item.value"
                                            [id]="i"
                                            formControlName="answer_type"
                                            type="radio"
                                            (click)="
                                              onSelectedType(item, questIndex)
                                            "
                                          />
                                          {{ item.viewValue }}
                                        </div>
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="field col-md-3 pull-left">
                                  <label class="label has-text-weight-bold"
                                    >Mark<span class="required"> *</span></label
                                  >
                                  <div class="control">
                                    <input
                                      type="text"
                                      class="input"
                                      name="mark"
                                      id="mark_{{ questIndex }}"
                                      placeholder="Enter the mark"
                                      formControlName="mark"
                                      (keydown)="keyDownHandler($event)"
                                      (keypress)="numericOnlyHandler($event)"
                                    />
                                    @if ( (assessmentCtrl.get('mark') .touched
                                    || assessmentCtrl.get('mark') .dirty) &&
                                    assessmentCtrl.get('mark').invalid ) {
                                    <div>
                                      @if
                                      (assessmentCtrl.get('mark').hasError('whitespace'))
                                      {
                                      <div class="has-text-danger is-size-7">
                                        Mark is required
                                      </div>
                                      }
                                    </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col">
                              <label class="label has-text-weight-bold"
                                >Question</label
                              >
                              <div class="col">
                                <input
                                  type="text"
                                  name="question"
                                  id="question_{{ questIndex }}"
                                  class="input"
                                  placeholder="Enter the question"
                                  formControlName="question"
                                  (keydown)="keyDownHandler($event)"
                                />
                                <a
                                  class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question"
                                  (click)="removeAssQuestion(questIndex)"
                                >
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                              </div>
                              <div class="col">
                                @if ( (assessmentCtrl.get('question').touched ||
                                assessmentCtrl.get('question').dirty) &&
                                assessmentCtrl.get('question').invalid ) {
                                <div>
                                  @if ( assessmentCtrl .get('question')
                                  .hasError('whitespace') ) {
                                  <div class="has-text-danger is-size-7">
                                    Question is required
                                  </div>
                                  }
                                </div>
                                }
                              </div>
                              <div class="row">
                                @if (isShown[questIndex]) {
                                <div
                                  class="question-option col-10 pull-right mt-2 ms-2"
                                  formArrayName="answer"
                                >
                                  <label class="label has-text-weight-bold"
                                    >Answers</label
                                  >
                                  @for ( answerCtrl of assQuestAnswers(
                                  questIndex ).controls; track answerCtrl; let
                                  optionIndex = $index) {
                                  <div class="control">
                                    <div
                                      class="mt-1"
                                      [formGroupName]="optionIndex"
                                    >
                                      <input
                                        type="text"
                                        name="answer"
                                        class="input"
                                        id="answer_{{ optionIndex }}"
                                        placeholder="Enter the answer"
                                        formControlName="answer"
                                        (keydown)="keyDownHandler($event)"
                                      />
                                      <input
                                        type="radio"
                                        class="is-checkradio"
                                        [ngClass]="{
                                          'is-danger':
                                            selectedOptions[questIndex]
                                        }"
                                        name="is_correct_answer{{ questIndex }}"
                                        id="isAnswer_{{ questIndex }}-{{
                                          optionIndex
                                        }}"
                                        value="{{ isChecked }}"
                                        (click)="
                                          oncheckedOptions(
                                            $event,
                                            assessmentCtrl,
                                            questIndex,
                                            optionIndex
                                          )
                                        "
                                        aria-label="Select correct answer"
                                      />
                                      <label
                                        class=""
                                        for="isAnswer_{{ questIndex }}-{{
                                          optionIndex
                                        }}"
                                        title="Check correct answer"
                                      ></label>
                                      @if ( assQuestAnswers(questIndex).controls
                                      .length > 1 ) {
                                      <a
                                        class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                        data-tooltip="Remove Answer"
                                        (click)="
                                          removeAssOptions(
                                            questIndex,
                                            optionIndex
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-times-circle"
                                          aria-hidden="true"
                                        ></i>
                                      </a>
                                      } @if ( (answerCtrl.get('answer').touched
                                      || answerCtrl.get('answer').dirty) &&
                                      answerCtrl.get('answer').invalid ) {
                                      <div>
                                        @if ( answerCtrl .get('answer')
                                        .hasError('whitespace') ) {
                                        <div class="has-text-danger is-size-7">
                                          Answer is required
                                        </div>
                                        }
                                      </div>
                                      } @if (
                                      (answerCtrl.get('is_correct_answer')
                                      .touched ||
                                      answerCtrl.get('is_correct_answer')
                                      .dirty) &&
                                      answerCtrl.get('is_correct_answer')
                                      .invalid ) {
                                      <div>
                                        @if (
                                        answerCtrl.get('is_correct_answer')
                                        .errors.required ) {
                                        <div>Check correct answer.</div>
                                        }
                                      </div>
                                      }
                                    </div>
                                  </div>
                                  }
                                  <a
                                    class="button is-link is-small has-tooltip-top mt-1"
                                    data-tooltip="Add more choice"
                                    (click)="onCreateAssOption(questIndex)"
                                  >
                                    <i
                                      class="fa-solid fa-circle-plus mar-0-5"
                                      aria-hidden="true"
                                    ></i>
                                    Add more choice
                                  </a>
                                </div>
                                } @if (selectedOptions[questIndex]) {
                                <p class="has-text-danger is-small is-size-7">
                                  Please select any one answer
                                </p>
                                }
                              </div>
                              <div class="col mt-2 pull-right">
                                <button
                                  class="button is-link is-small has-tooltip-top"
                                  (click)="onCreateAssQuestion()"
                                >
                                  <i
                                    class="fa-solid fa-circle-plus mar-0-5"
                                    aria-hidden="true"
                                  ></i>
                                  Add new question
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        }
                      </ng-container>
                    </div>
                  </div>

                  <div class="field" style="display: none">
                    @if (!domElementControl.showCreateNewQuestions) {
                    <a
                      class="button is-link is-outlined is-small has-tooltip-top mar-0-5"
                      data-tooltip="Add your first question"
                      (click)="onCreateAssQuestion()"
                    >
                      <i
                        class="fa-solid fa-circle-plus mar-0-5"
                        aria-hidden="true"
                      ></i>
                      Add your assessment question
                    </a>
                    } @if ( domElementControl.showCreateNewQuestions &&
                    is_question_found ) {
                    <section class="section">
                      <div class="columns">
                        <div class="column">
                          <div class="field">
                            <label class="label">Minimum % required</label>
                            <div class="control">
                              <input
                                type="text"
                                class="input"
                                name="min_percentage"
                                placeholder="%"
                                formControlName="min_percentage"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="column">
                          <label class="">Allow to Re-Test?</label>
                          <div class="field responsiveRadioBtn">
                            <input
                              id="switchReTest"
                              type="checkbox"
                              name="is_allow_retest"
                              class="switch is-small is-success"
                              formControlName="is_allow_retest"
                              [(ngModel)]="isAllowRetest"
                            />
                            <label for="switchReTest"></label>
                          </div>
                        </div>
                        <div class="column">
                          <div class="field">
                            <label class="label"
                              >No.of Random Question
                              <span class="required">*</span></label
                            >
                            <div class="control">
                              <input
                                type="text"
                                class="input"
                                name="random_question"
                                placeholder=""
                                formControlName="random_question"
                                (keydown)="keyDownHandler($event)"
                                (keypress)="numericOnlyHandler($event)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="container" formArrayName="assessment">
                        @for ( assessmentCtrl of assQuestion().controls; track
                        assessmentCtrl; let questIndex = $index) {
                        <div class="questionnarie">
                          <div class="" [formGroupName]="questIndex">
                            <input
                              type="text"
                              name="question"
                              id="question_{{ questIndex }}"
                              class="input"
                              placeholder="Enter the question"
                              formControlName="question"
                              (keydown)="keyDownHandler($event)"
                            />
                            @if (assQuestion().length > 1) {
                            <a
                              class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                              data-tooltip="Remove Question"
                              (click)="removeAssQuestion(questIndex)"
                            >
                              <i class="fa fa-times-circle mar-0-5"></i>
                            </a>
                            } @if ( (assessmentCtrl.get('question').touched ||
                            assessmentCtrl.get('question').dirty) &&
                            assessmentCtrl.get('question').invalid ) {
                            <div>
                              @if ( assessmentCtrl .get('question')
                              .hasError('whitespace') ) {
                              <div class="has-text-danger is-size-6">
                                Field is required
                              </div>
                              }
                            </div>
                            }
                            <div class="question-choice">
                              <div class="field">
                                <div class="label">
                                  <label class="label"
                                    >Question Type
                                    <span class="required"> *</span>
                                  </label>
                                  <span class="control">
                                    @for ( item of questions; track item; let i
                                    = $index) {
                                    <div class="radio">
                                      <input
                                        [value]="item.value"
                                        [id]="i"
                                        formControlName="answer_type"
                                        type="radio"
                                        (click)="
                                          onSelectedType(item, questIndex)
                                        "
                                      />
                                      {{ item.viewValue }}
                                    </div>
                                    }
                                  </span>
                                </div>
                                <!-- <div class="field-body">
                                                                                                  <div class="field is-narrow">
                                                                                                  </div>
                                                                                                </div> -->
                              </div>
                            </div>
                            @if (isShown[questIndex]) {
                            <div class="question-option" formArrayName="answer">
                              @for ( answerCtrl of assQuestAnswers( questIndex
                              ).controls; track answerCtrl; let optionIndex =
                              $index) {
                              <div class="control">
                                <div class="" [formGroupName]="optionIndex">
                                  <input
                                    type="text"
                                    name="answer"
                                    class="input"
                                    id="answer_{{ optionIndex }}"
                                    placeholder="Enter the answer"
                                    formControlName="answer"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <input
                                    type="radio"
                                    class="is-checkradio"
                                    [ngClass]="{
                                      'is-danger': selectedOptions[questIndex]
                                    }"
                                    name="is_correct_answer{{ questIndex }}"
                                    id="isAnswer_{{ questIndex }}-{{
                                      optionIndex
                                    }}"
                                    value="{{ isChecked }}"
                                    (click)="
                                      oncheckedOptions(
                                        $event,
                                        assessmentCtrl,
                                        questIndex,
                                        optionIndex
                                      )
                                    "
                                    aria-label="Select correct answer"
                                  />
                                  <label
                                    class=""
                                    for="isAnswer_{{ questIndex }}-{{
                                      optionIndex
                                    }}"
                                    title="Check correct answer"
                                  ></label>
                                  @if ( assQuestAnswers(questIndex).controls
                                  .length > 1 ) {
                                  <a
                                    class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                    data-tooltip="Remove Answer"
                                    (click)="
                                      removeAssOptions(questIndex, optionIndex)
                                    "
                                  >
                                    <i
                                      class="fa fa-times-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                  } @if ( (answerCtrl.get('answer').touched ||
                                  answerCtrl.get('answer').dirty) &&
                                  answerCtrl.get('answer').invalid ) {
                                  <div>
                                    @if ( answerCtrl .get('answer')
                                    .hasError('whitespace') ) {
                                    <div class="has-text-danger is-size-6">
                                      Answer is required
                                    </div>
                                    }
                                  </div>
                                  } @if ( (answerCtrl.get('is_correct_answer')
                                  .touched ||
                                  answerCtrl.get('is_correct_answer') .dirty) &&
                                  answerCtrl.get('is_correct_answer') .invalid )
                                  {
                                  <div>
                                    @if ( answerCtrl.get('is_correct_answer')
                                    .errors.required ) {
                                    <div>Check correct answer.</div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              }
                              <a
                                class="button is-link is-outlined is-small has-tooltip-top"
                                data-tooltip="Add more choice"
                                (click)="onCreateAssOption(questIndex)"
                              >
                                <i
                                  class="fa-solid fa-circle-plus mar-0-5"
                                  aria-hidden="true"
                                ></i>
                                Add more choice
                              </a>
                            </div>
                            }
                            <div class="columns questionnarieAns">
                              <div class="column is-6">
                                <div class="field">
                                  <br />
                                  Mark
                                  <div class="control">
                                    <input
                                      type="text"
                                      class="input"
                                      name="mark"
                                      id="mark_{{ questIndex }}"
                                      placeholder="Enter the mark"
                                      formControlName="mark"
                                      (keydown)="keyDownHandler($event)"
                                      (keypress)="numericOnlyHandler($event)"
                                    />
                                    @if ( (assessmentCtrl.get('mark') .touched
                                    || assessmentCtrl.get('mark') .dirty) &&
                                    assessmentCtrl.get('mark').invalid ) {
                                    <div>
                                      @if ( assessmentCtrl .get('mark')
                                      .hasError('whitespace') ) {
                                      <div class="has-text-danger is-size-6">
                                        Mark is required
                                      </div>
                                      }
                                    </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (selectedOptions[questIndex]) {
                          <p class="has-text-danger is-small is-size-6">
                            Please select any one answer
                          </p>
                          }
                        </div>
                        }
                        <button
                          class="button is-link is-outlined is-small has-tooltip-top"
                          (click)="onCreateAssQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add new question
                        </button>
                      </div>
                    </section>
                    }
                  </div>
                </div>

                <div
                  id="survey"
                  class="survey_question content-tab row"
                  style="display: none"
                >
                  <div class="col">
                    <div class="row">
                      <div class="col-3">
                        @if (!domElementControl.showCreateNewSurQuestion) {
                        <a
                          class="button is-link is-small has-tooltip-top"
                          (click)="onCreateSurveyQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add your survey question
                        </a>
                        }
                      </div>
                    </div>
                    <div class="row">
                      @if (domElementControl.showCreateNewSurQuestion &&
                      is_survey_found) {
                      <ng-container formArrayName="survey">
                        @for (surveyCtrl of surveyQuestions().controls; track
                        surveyCtrl; let questIndex = $index) {
                        <div class="questionnarie row">
                          <div [formGroupName]="questIndex">
                            <div class="col">
                              <label class="label has-text-weight-bold"
                                >Question</label
                              >
                              <div class="col">
                                <input
                                  type="text"
                                  name="question"
                                  id="question_{{ questIndex }}"
                                  class="input"
                                  placeholder="Enter the question"
                                  formControlName="question"
                                  (keydown)="keyDownHandler($event)"
                                />
                                @if (surveyQuestions().controls.length > 1) {
                                <a
                                  class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question"
                                  (click)="onRemoveSurveyQuestion(questIndex)"
                                >
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                                }
                              </div>
                              <div class="col">
                                @if ((surveyCtrl.get('question').touched ||
                                surveyCtrl.get('question').dirty) &&
                                surveyCtrl.get('question').invalid) {
                                <div>
                                  @if ( surveyCtrl .get('question')
                                  .hasError('whitespace') ) {
                                  <div class="has-text-danger is-size-7">
                                    Question is required
                                  </div>
                                  }
                                </div>
                                }
                              </div>
                            </div>
                            <div class="col mt-2">
                              <label class="label has-text-weight-bold"
                                >Answers</label
                              >
                              <div class="row">
                                <div
                                  class="question-option col-10 pull-right ms-2"
                                  formArrayName="answer"
                                >
                                  @for ( answerCtrl of surveyOptions( questIndex
                                  ).controls; track answerCtrl; let optionIndex
                                  = $index) {
                                  <div class="control mb-2">
                                    <div [formGroupName]="optionIndex">
                                      <input
                                        type="text"
                                        name="answer"
                                        class="input"
                                        id="answer_{{ optionIndex }}"
                                        placeholder="Enter the answer"
                                        formControlName="answer"
                                        (keydown)="keyDownHandler($event)"
                                      />
                                      @if ( surveyOptions(questIndex).controls
                                      .length > 1 ) {
                                      <a
                                        class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                        data-tooltip="Remove Answer"
                                        (click)="
                                          removeSurveyOptions(
                                            questIndex,
                                            optionIndex
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-times-circle"
                                          aria-hidden="true"
                                        ></i>
                                      </a>
                                      } @if ( (answerCtrl.get('answer').touched
                                      || answerCtrl.get('answer').dirty) &&
                                      answerCtrl.get('answer').invalid ) {
                                      <div>
                                        @if ( answerCtrl .get('answer')
                                        .hasError('whitespace') ) {
                                        <div class="has-text-danger is-size-7">
                                          Answer is required
                                        </div>
                                        }
                                      </div>
                                      }
                                    </div>
                                  </div>
                                  }
                                  <a
                                    class="button is-link is-small has-tooltip-top"
                                    data-tooltip="Add more choice"
                                    (click)="oncreateSurveyOptions(questIndex)"
                                  >
                                    <i
                                      class="fa-solid fa-circle-plus mar-0-5"
                                      aria-hidden="true"
                                    ></i>
                                    Add more choice
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="col mt-2 pull-right">
                              <a
                                class="button is-link is-small has-tooltip-top"
                                data-tooltip="Add new question"
                                (click)="onCreateSurveyQuestion()"
                              >
                                <i
                                  class="fa-solid fa-circle-plus mar-0-5"
                                  aria-hidden="true"
                                ></i>
                                Add new question
                              </a>
                            </div>
                          </div>
                        </div>
                        }
                      </ng-container>
                      }
                    </div>
                    @if ( domElementControl.showCreateNewSurQuestion &&
                    is_survey_found ) {
                    <section style="display: none" class="section">
                      <div class="container" formArrayName="survey">
                        @for ( surveyCtrl of surveyQuestions().controls; track
                        surveyCtrl; let questIndex = $index) {
                        <div class="questionnarie">
                          <div class="" [formGroupName]="questIndex">
                            <input
                              type="text"
                              name="question"
                              id="question_{{ questIndex }}"
                              class="input"
                              placeholder="Enter the question"
                              formControlName="question"
                              (keydown)="keyDownHandler($event)"
                            />
                            @if (surveyQuestions().controls.length > 1) {
                            <a
                              class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                              data-tooltip="Remove Question"
                              (click)="onRemoveSurveyQuestion(questIndex)"
                            >
                              <i class="fa fa-times-circle mar-0-5"></i>
                            </a>
                            } @if ( (surveyCtrl.get('question').touched ||
                            surveyCtrl.get('question').dirty) &&
                            surveyCtrl.get('question').invalid ) {
                            <div>
                              @if ( surveyCtrl .get('question')
                              .hasError('whitespace') ) {
                              <div class="has-text-danger is-size-6">
                                Question is required
                              </div>
                              }
                            </div>
                            }
                            <div class="question-option" formArrayName="answer">
                              @for ( answerCtrl of surveyOptions( questIndex
                              ).controls; track answerCtrl; let optionIndex =
                              $index) {
                              <div class="control">
                                <div class="" [formGroupName]="optionIndex">
                                  <input
                                    type="text"
                                    name="answer"
                                    class="input"
                                    id="answer_{{ optionIndex }}"
                                    placeholder="Enter the answer"
                                    formControlName="answer"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  @if ( surveyOptions(questIndex).controls
                                  .length > 1 ) {
                                  <a
                                    class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                    data-tooltip="Remove Answer"
                                    (click)="
                                      removeSurveyOptions(
                                        questIndex,
                                        optionIndex
                                      )
                                    "
                                  >
                                    <i
                                      class="fa fa-times-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                  } @if ( (answerCtrl.get('answer').touched ||
                                  answerCtrl.get('answer').dirty) &&
                                  answerCtrl.get('answer').invalid ) {
                                  <div>
                                    @if ( answerCtrl .get('answer')
                                    .hasError('whitespace') ) {
                                    <div class="has-text-danger is-size-6">
                                      Answer is required
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              }
                              <a
                                class="button is-link is-outlined is-small has-tooltip-top"
                                data-tooltip="Add more choice"
                                (click)="oncreateSurveyOptions(questIndex)"
                              >
                                <i
                                  class="fa-solid fa-circle-plus mar-0-5"
                                  aria-hidden="true"
                                ></i>
                                Add more choice
                              </a>
                            </div>
                          </div>
                        </div>
                        }
                        <a
                          class="button is-link is-outlined is-small has-tooltip-top"
                          data-tooltip="Add new question"
                          (click)="onCreateSurveyQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add new question
                        </a>
                      </div>
                    </section>
                    }
                  </div>
                </div>
                <div id="poll" class="content-tab row" style="display: none">
                  <div class="col">
                    <div class="row">
                      <div class="col-3">
                        @if (!domElementControl.showCreateNewPolQuestion) {
                        <a
                          class="button is-link is-small has-tooltip-top"
                          (click)="onCreatePollQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add your poll question
                        </a>
                        }
                      </div>
                    </div>
                    <div class="row">
                      @if (domElementControl.showCreateNewPolQuestion &&
                      is_polls_found) {
                      <ng-container formArrayName="polls">
                        @for (pollCtrl of pollQuestions().controls; track
                        pollCtrl; let questIndex = $index) {
                        <div class="questionnarie row">
                          <div [formGroupName]="questIndex">
                            <div class="col">
                              <label class="label has-text-weight-bold"
                                >Question</label
                              >
                              <div class="col">
                                <input
                                  type="text"
                                  name="question"
                                  id="question_{{ questIndex }}"
                                  class="input"
                                  placeholder="Enter the question"
                                  formControlName="question"
                                  (keydown)="keyDownHandler($event)"
                                />
                                @if (pollQuestions().length > 1) {
                                <a
                                  class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question"
                                  (click)="removePollQuestion(questIndex)"
                                >
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                                }
                              </div>
                            </div>
                            <div class="col">
                              @if ( (pollCtrl.get('question').touched ||
                              pollCtrl.get('question').dirty) &&
                              pollCtrl.get('question').invalid ) {
                              <div>
                                @if ( pollCtrl .get('question')
                                .hasError('whitespace') ) {
                                <div class="has-text-danger is-size-7">
                                  Question is required
                                </div>
                                }
                              </div>
                              }
                            </div>
                            <div class="col mt-2">
                              <label class="label has-text-weight-bold"
                                >Answers</label
                              >
                              <div class="row">
                                <div
                                  class="question-option col-10 pull-right ms-2"
                                  formArrayName="answer"
                                >
                                  @for ( answerCtrl of pollChoices(questIndex)
                                  .controls; track answerCtrl; let optionIndex =
                                  $index) {
                                  <div class="control mb-2">
                                    <div class="" [formGroupName]="optionIndex">
                                      <input
                                        type="text"
                                        name="answer"
                                        class="input"
                                        id="answer_{{ optionIndex }}"
                                        placeholder="Enter the answer"
                                        formControlName="answer"
                                        (keydown)="keyDownHandler($event)"
                                      />
                                      @if ( pollChoices(questIndex).controls
                                      .length > 1 ) {
                                      <a
                                        class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                        data-tooltip="Remove Answer"
                                        (click)="
                                          removePollChoice(
                                            questIndex,
                                            optionIndex
                                          )
                                        "
                                      >
                                        <i
                                          class="fa fa-times-circle"
                                          aria-hidden="true"
                                        ></i>
                                      </a>
                                      } @if ( (answerCtrl.get('answer').touched
                                      || answerCtrl.get('answer').dirty) &&
                                      answerCtrl.get('answer').invalid ) {
                                      <div>
                                        @if ( answerCtrl .get('answer')
                                        .hasError('whitespace') ) {
                                        <div class="has-text-danger is-size-7">
                                          Answer is required
                                        </div>
                                        }
                                      </div>
                                      }
                                    </div>
                                  </div>
                                  }
                                  <a
                                    class="button is-link is-small has-tooltip-top"
                                    data-tooltip="Add more choice"
                                    (click)="onCreatePollChoice(questIndex)"
                                  >
                                    <i
                                      class="fa-solid fa-circle-plus mar-0-5"
                                      aria-hidden="true"
                                    ></i>
                                    Add more choice
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="col mt-2 pull-right">
                              <a
                                class="button is-link is-small has-tooltip-top"
                                data-tooltip="Add new question"
                                (click)="onCreatePollQuestion()"
                              >
                                <i
                                  class="fa-solid fa-circle-plus mar-0-5"
                                  aria-hidden="true"
                                ></i>
                                Add new question
                              </a>
                            </div>
                          </div>
                        </div>
                        }
                      </ng-container>
                      }
                    </div>
                  </div>
                  <div class="field" style="display: none">
                    @if (!domElementControl.showCreateNewPolQuestion) {
                    <a
                      class="button is-link is-outlined is-small has-tooltip-top"
                      (click)="onCreatePollQuestion()"
                    >
                      <i
                        class="fa-solid fa-circle-plus mar-0-5"
                        aria-hidden="true"
                      ></i>
                      Add your poll question
                    </a>
                    } @if ( domElementControl.showCreateNewPolQuestion &&
                    is_polls_found ) {
                    <section class="section">
                      <div class="container" formArrayName="polls">
                        @for ( pollCtrl of pollQuestions().controls; track
                        pollCtrl; let questIndex = $index) {
                        <div class="questionnarie">
                          <div class="" [formGroupName]="questIndex">
                            <input
                              type="text"
                              name="question"
                              id="question_{{ questIndex }}"
                              class="input"
                              placeholder="Enter the question"
                              formControlName="question"
                              (keydown)="keyDownHandler($event)"
                            />
                            @if (pollQuestions().length > 1) {
                            <a
                              class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                              data-tooltip="Remove Question"
                              (click)="removePollQuestion(questIndex)"
                            >
                              <i class="fa fa-times-circle mar-0-5"></i>
                            </a>
                            } @if ( (pollCtrl.get('question').touched ||
                            pollCtrl.get('question').dirty) &&
                            pollCtrl.get('question').invalid ) {
                            <div>
                              @if ( pollCtrl .get('question')
                              .hasError('whitespace') ) {
                              <div class="has-text-danger is-size-6">
                                Question is required
                              </div>
                              }
                            </div>
                            }
                            <div class="question-option" formArrayName="answer">
                              @for ( answerCtrl of pollChoices(questIndex)
                              .controls; track answerCtrl; let optionIndex =
                              $index) {
                              <div class="control">
                                <div class="" [formGroupName]="optionIndex">
                                  <input
                                    type="text"
                                    name="answer"
                                    class="input"
                                    id="answer_{{ optionIndex }}"
                                    placeholder="Enter the answer"
                                    formControlName="answer"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  @if ( pollChoices(questIndex).controls .length
                                  > 1 ) {
                                  <a
                                    class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                    data-tooltip="Remove Answer"
                                    (click)="
                                      removePollChoice(questIndex, optionIndex)
                                    "
                                  >
                                    <i
                                      class="fa fa-times-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                  } @if ( (answerCtrl.get('answer').touched ||
                                  answerCtrl.get('answer').dirty) &&
                                  answerCtrl.get('answer').invalid ) {
                                  <div>
                                    @if ( answerCtrl .get('answer')
                                    .hasError('whitespace') ) {
                                    <div class="has-text-danger is-size-6">
                                      Answer is required
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              }
                              <a
                                class="button is-link is-outlined is-small has-tooltip-top"
                                data-tooltip="Add more choice"
                                (click)="onCreatePollChoice(questIndex)"
                              >
                                <i
                                  class="fa-solid fa-circle-plus mar-0-5"
                                  aria-hidden="true"
                                ></i>
                                Add more choice
                              </a>
                            </div>
                          </div>
                        </div>
                        }
                        <a
                          class="button is-link is-outlined is-small has-tooltip-top"
                          data-tooltip="Add new question"
                          (click)="onCreatePollQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add new question
                        </a>
                      </div>
                    </section>
                    }
                  </div>
                </div>
                <div id="notes" class="content-tab row" style="display: none">
                  <div class="col">
                    <div class="row">
                      <div class="col-3">
                        @if (!domElementControl.showCreateNewNotesQuestion) {
                        <a
                          class="button is-link is-small has-tooltip-top"
                          (click)="onCreateNotesQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add your notes question
                        </a>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        @if (domElementControl.showCreateNewNotesQuestion &&
                        is_notes_found) {
                        <ng-container formArrayName="notes">
                          @for ( notesCtrl of notesQuestions().controls; track
                          notesCtrl; let questIndex = $index) {
                          <div class="questionnarie row">
                            <div class="row" [formGroupName]="questIndex">
                              <div class="col-11 mb-2">
                                <angular-editor
                                  class="scroll-bar"
                                  id="question_{{ questIndex }}"
                                  formControlName="question"
                                  [config]="editorNotesConfig"
                                  cols="10"
                                  rows="5"
                                ></angular-editor>
                              </div>
                              <div class="col-1">
                                @if (notesQuestions().length > 1) {
                                <a
                                  class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question"
                                  (click)="removeNotesQuestion(questIndex)"
                                >
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                                }
                              </div>
                            </div>
                            @if ( (notesCtrl.get('question').touched ||
                            notesCtrl.get('question').dirty) &&
                            notesCtrl.get('question').invalid ) {
                            <div class="col">
                              @if ( notesCtrl .get('question')
                              .hasError('whitespace') ) {
                              <div class="has-text-danger is-size-6">
                                Question is required
                              </div>
                              }
                            </div>
                            }
                          </div>
                          }
                        </ng-container>
                        }
                      </div>
                    </div>
                    @if (notesQuestions().controls.length > 0) {
                    <div class="row mb-2">
                      <div class="col mt-2">
                        <a
                          class="button is-link pull-right is-small has-tooltip-top"
                          data-tooltip="Add new question"
                          (click)="onCreateNotesQuestion()"
                        >
                          <i
                            class="fa-solid fa-circle-plus mar-0-5"
                            aria-hidden="true"
                          ></i>
                          Add new notes question
                        </a>
                      </div>
                    </div>
                    }
                  </div>
                  <div class="field" style="display: none">
                    @if (!domElementControl.showCreateNewNotesQuestion) {
                    <a
                      class="button is-link is-outlined is-small has-tooltip-top"
                      (click)="onCreateNotesQuestion()"
                    >
                      <i
                        class="fa-solid fa-circle-plus mar-0-5"
                        aria-hidden="true"
                      ></i>
                      Add your notes question
                    </a>
                    }
                  </div>
                  @if ( domElementControl.showCreateNewNotesQuestion &&
                  is_notes_found ) {
                  <section style="display: none" class="section">
                    <div class="container" formArrayName="notes">
                      @for ( notesCtrl of notesQuestions().controls; track
                      notesCtrl; let questIndex = $index) {
                      <div class="questionnarie">
                        <div class="" [formGroupName]="questIndex">
                          <angular-editor
                            class="scroll-bar"
                            id="question_{{ questIndex }}"
                            formControlName="question"
                            [config]="editorNotesConfig"
                            cols="10"
                            rows="5"
                          ></angular-editor>
                          @if (notesQuestions().length > 1) {
                          <a
                            class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                            data-tooltip="Remove Question"
                            (click)="removeNotesQuestion(questIndex)"
                          >
                            <i class="fa fa-times-circle mar-0-5"></i>
                          </a>
                          } @if ( (notesCtrl.get('question').touched ||
                          notesCtrl.get('question').dirty) &&
                          notesCtrl.get('question').invalid ) {
                          <div>
                            @if ( notesCtrl .get('question')
                            .hasError('whitespace') ) {
                            <div class="has-text-danger is-size-7">
                              Question is required
                            </div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      <a
                        class="button is-link is-outlined is-small has-tooltip-top"
                        data-tooltip="Add new question"
                        (click)="onCreateNotesQuestion()"
                      >
                        <i
                          class="fa-solid fa-circle-plus mar-0-5"
                          aria-hidden="true"
                        ></i>
                        Add new notes question
                      </a>
                    </div>
                  </section>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
        <footer class="card-footer">
          <div class="columns is-fullwidth">
            <div class="column is-6 lessonPublish">
              <!-- <div class="field responsiveRadioBtn">
                                                                                                  <input
                                                                                                    id="switchPublish"
                                                                                                    type="checkbox"
                                                                                                    name="publish"
                                                                                                    class="switch is-small is-success"
                                                                                                    formControlName="publish"
                                                                                                    [(ngModel)]="isPublish"
                                                                                                    />
                                                                                                    <label for="switchPublish">Publish this lesson?</label>
                                                                                                  </div> -->
            </div>
            <div class="column is-6 lessonSubmitBtn has-text-right">
              <button
                type="button"
                class="button mar-0-5 is-small"
                (click)="hideFileUploadModal(upLoadedFileList)"
              >
                Cancel
              </button>
              @if (!showBtnSpinner) {
              <button
                type="button"
                class="button is-link is-small disabledBtn"
                (click)="createNewFileData(uploadFileForm.value)"
                [disabled]="
                  !uploadFileForm.valid || upLoadedFileList.length === 0
                "
              >
                <i class="fa fa-upload is-small mar-0-5"></i> Upload
              </button>
              } @if (showBtnSpinner) {
              <a
                class="button is-link is-loading is-small"
                style="min-width: 100px"
              ></a>
              }
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
